import { Dialog, DialogContent, Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface EnrollSuccessDialogProps {
  open: boolean;
  courseName?: string;
  onClose: () => void;
}

const EnrollSuccessDialog = ({ open, courseName, onClose }: EnrollSuccessDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: { borderRadius: "16px", p: 3, textAlign: "center", maxWidth: 380 },
    }}
  >
    <DialogContent>
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          background: "rgba(34,197,94,0.12)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 2,
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 36, color: "#22c55e" }} />
      </Box>
      <Typography variant="h6" fontWeight={700} mb={1}>
        You're Enrolled! 🎉
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {courseName
          ? `You've successfully enrolled in "${courseName}".`
          : "You've successfully enrolled in this course."}
      </Typography>
      <Button
        fullWidth
        variant="contained"
        onClick={onClose}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          background: "linear-gradient(90deg, #036AB7 0%, #4BA5EB 100%)",
          borderRadius: "8px",
          py: 1.2,
        }}
      >
        Continue
      </Button>
    </DialogContent>
  </Dialog>
);

export default EnrollSuccessDialog;